package songwritersnotebook.app.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Menu
import androidx.compose.material.icons.filled.MusicNote
import songwritersnotebook.app.viewmodels.MainViewModel
import org.jetbrains.compose.resources.painterResource
import songwritersnotebookapp.composeapp.generated.resources.Res
import songwritersnotebookapp.composeapp.generated.resources.ic_logo_fg

@Composable
fun WebNavHeader(
    mainViewModel: MainViewModel,
    onSignIn: () -> Unit,
    onFeatures: () -> Unit,
    onPricing: () -> Unit,
    onRoadmap: () -> Unit,
    onHome: () -> Unit,
    selectedRoute: String? = null
) {
    var showMobileMenu by remember { mutableStateOf(false) }

    Surface(
        modifier = Modifier.fillMaxWidth().height(72.dp),
        color = Color(0xFF0F172A), // Dark slate to match the top of the marketing page nebula
        tonalElevation = 0.dp
    ) {
        BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
            val isMobile = maxWidth < 1000.dp
            val user by mainViewModel.currentUser.collectAsState()

            Row(
                modifier = Modifier.fillMaxSize().padding(horizontal = if (isMobile) 16.dp else (maxWidth * 0.05f)), // 5% padding like CSS
                verticalAlignment = Alignment.CenterVertically
            ) {
                // Logo & Title
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                        onClick = onHome
                    )
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.ic_logo_fg),
                        contentDescription = "Logo",
                        modifier = Modifier.size(40.dp),
                        tint = MaterialTheme.colorScheme.primary
                    )
                    Spacer(Modifier.width(16.dp))
                    Text(
                        if (isMobile) "SN" else "Songwriter's Notebook",
                        style = MaterialTheme.typography.titleLarge,
                        fontWeight = FontWeight.ExtraBold,
                        color = Color.White,
                        letterSpacing = (-0.5).sp,
                        fontSize = if (isMobile) 24.sp else 24.sp
                    )
                }

                Spacer(Modifier.weight(1f))

                if (!isMobile) {
                    // Desktop Navigation Links
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(32.dp)
                    ) {
                        TextButton(onClick = onFeatures) {
                            Text(
                                "Features", 
                                color = if (selectedRoute == "features") Color.White else Color.White.copy(alpha = 0.8f),
                                fontWeight = FontWeight.Medium,
                                fontSize = 16.sp
                            )
                        }
                        TextButton(onClick = onPricing) {
                            Text(
                                "Pricing", 
                                color = if (selectedRoute == "pricing") Color.White else Color.White.copy(alpha = 0.8f),
                                fontWeight = FontWeight.Medium,
                                fontSize = 16.sp
                            )
                        }
                        TextButton(onClick = onRoadmap) {
                            Text(
                                "Roadmap", 
                                color = if (selectedRoute == "roadmap") Color.White else Color.White.copy(alpha = 0.8f),
                                fontWeight = FontWeight.Medium,
                                fontSize = 16.sp
                            )
                        }
                        
                        // "Sign In" / "Launch App" button exactly like .btn-launch
                        Button(
                            onClick = { if (user == null) onSignIn() else onHome() },
                            colors = ButtonDefaults.buttonColors(
                                containerColor = MaterialTheme.colorScheme.primary,
                                contentColor = Color.White
                            ),
                            shape = androidx.compose.foundation.shape.RoundedCornerShape(50),
                            contentPadding = PaddingValues(horizontal = 24.dp, vertical = 8.dp)
                        ) {
                            Text(
                                if (user == null) "Sign In" else "Launch App",
                                fontWeight = FontWeight.SemiBold,
                                fontSize = 16.sp
                            )
                        }
                    }
                } else {
                    // Mobile Navigation
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Button(
                            onClick = { if (user == null) onSignIn() else onHome() },
                            colors = ButtonDefaults.buttonColors(
                                containerColor = MaterialTheme.colorScheme.primary,
                                contentColor = Color.White
                            ),
                            shape = androidx.compose.foundation.shape.RoundedCornerShape(50),
                            contentPadding = PaddingValues(horizontal = 16.dp),
                            modifier = Modifier.height(36.dp)
                        ) {
                            Text(
                                if (user == null) "Sign In" else "Launch",
                                fontWeight = FontWeight.SemiBold,
                                fontSize = 14.sp
                            )
                        }

                        Spacer(modifier = Modifier.width(8.dp))

                        IconButton(onClick = { showMobileMenu = true }) {
                            Icon(Icons.Default.Menu, contentDescription = "Menu", tint = Color.White)
                        }
                        
                        DropdownMenu(
                            expanded = showMobileMenu,
                            onDismissRequest = { showMobileMenu = false }
                        ) {
                            DropdownMenuItem(
                                text = { Text("Home") },
                                onClick = { showMobileMenu = false; onHome() }
                            )
                            DropdownMenuItem(
                                text = { Text("Features") },
                                onClick = { showMobileMenu = false; onFeatures() }
                            )
                            DropdownMenuItem(
                                text = { Text("Pricing") },
                                onClick = { showMobileMenu = false; onPricing() }
                            )
                            DropdownMenuItem(
                                text = { Text("Roadmap") },
                                onClick = { showMobileMenu = false; onRoadmap() }
                            )
                        }
                    }
                }
            }
        }
    }
}

